"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { trackProductClicked } from "@/lib/analytics/segment";
import { useTrendingProducts } from "@/queries/useTrendingProducts";
import { useSearchPanelStore } from "@/stores/useSearchPanelStore";
import { SearchSectionSkeleton } from "./SearchSectionSkeleton";
export function TrendingProductsList() {
  const $ = _c(9);
  const close = useSearchPanelStore(_temp);
  const {
    data,
    isLoading,
    isError
  } = useTrendingProducts();
  if (isError) {
    return null;
  }
  if (isLoading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <section className="flex flex-col gap-3"><h3 className="heading-sm">Trending Products</h3><SearchSectionSkeleton testId="trending-products-skeleton" itemClassName="h-16 w-full" /></section>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (!data || data.length === 0) {
    return null;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h3 className="heading-sm">Trending Products</h3>;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== close || $[3] !== data) {
    let t2;
    if ($[5] !== close) {
      t2 = (ref, index) => <li key={ref.sku}><Link href={`/${ref.slug}`} onClick={() => {
          trackProductClicked({
            product_id: ref.sku,
            sku: ref.sku,
            name: ref.name,
            position: index + 1,
            url: `/${ref.slug}`,
            ...(ref.imageUrl ? {
              image_url: ref.imageUrl
            } : {})
          });
          close();
        }} className="flex items-stretch gap-3 rounded-md py-3 font-normal no-underline! hover:opacity-100!">{ref.imageUrl && <div className="relative aspect-square w-16 shrink-0 self-start"><Image src={ref.imageUrl} alt={ref.name} fill={true} sizes="64px" className="rounded-md object-contain" /></div>}<div className="flex min-w-0 flex-1 flex-col gap-1"><p className="text-sm font-semibold leading-tight text-foreground">{ref.name}</p>{ref.description && <p className="line-clamp-2 text-xs leading-snug text-muted-foreground">{ref.description}</p>}</div></Link></li>;
      $[5] = close;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = data.map(t2);
    $[2] = close;
    $[3] = data;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <section className="flex flex-col gap-3">{t0}<ul className="flex flex-col">{t1}</ul></section>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp(state) {
  return state.close;
}